var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid p-0 mt-0" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-header", attrs: { "data-profile-tabs": "" } },
            [
              _c(
                "nav",
                {
                  staticClass: "nav nav-tabs",
                  attrs: { role: "tablist", "data-profile-navtabs": "" }
                },
                [
                  _vm.profile.is_own_profile || !_vm.profile.is_private
                    ? _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link",
                          class: {
                            active:
                              _vm.currentSelectedTab ===
                              _vm.ViewProfileTabs.Badges
                          },
                          attrs: { href: "#" + _vm.ViewProfileTabs.Badges },
                          on: {
                            click: function($event) {
                              _vm.currentSelectedTab =
                                _vm.ViewProfileTabs.Badges
                            }
                          }
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.T.wordsBadgesObtained) + " "),
                          _c("span", { staticClass: "badge badge-secondary" }, [
                            _vm._v(" " + _vm._s(_vm.profileBadges.size) + " ")
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm.profile.is_own_profile || !_vm.profile.is_private
                    ? _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link",
                          class: {
                            active:
                              _vm.currentSelectedTab ===
                              _vm.ViewProfileTabs.Problems
                          },
                          attrs: { href: "#" + _vm.ViewProfileTabs.Problems },
                          on: {
                            click: function($event) {
                              _vm.currentSelectedTab =
                                _vm.ViewProfileTabs.Problems
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.T.wordsProblems))]
                      )
                    : _vm._e(),
                  _vm.profile.is_own_profile || !_vm.profile.is_private
                    ? _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link",
                          class: {
                            active:
                              _vm.currentSelectedTab ===
                              _vm.ViewProfileTabs.Contests
                          },
                          attrs: { href: "#" + _vm.ViewProfileTabs.Contests },
                          on: {
                            click: function($event) {
                              _vm.currentSelectedTab =
                                _vm.ViewProfileTabs.Contests
                            }
                          }
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.T.profileContests) + " "),
                          _c("span", { staticClass: "badge badge-secondary" }, [
                            _vm._v(
                              " " +
                                _vm._s(Object.keys(_vm.contests).length) +
                                " "
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm.profile.is_own_profile || !_vm.profile.is_private
                    ? _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link",
                          class: {
                            active:
                              _vm.currentSelectedTab ===
                              _vm.ViewProfileTabs.CreatedContent
                          },
                          attrs: {
                            href: "#" + _vm.ViewProfileTabs.CreatedContent,
                            "data-created-content-tab": ""
                          },
                          on: {
                            click: function($event) {
                              _vm.currentSelectedTab =
                                _vm.ViewProfileTabs.CreatedContent
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.T.profileCreatedContent))]
                      )
                    : _vm._e(),
                  _c(
                    "a",
                    {
                      staticClass: "nav-item nav-link",
                      class: {
                        active:
                          _vm.currentSelectedTab === _vm.ViewProfileTabs.Data
                      },
                      attrs: { href: "#" + _vm.ViewProfileTabs.Data },
                      on: {
                        click: function($event) {
                          _vm.currentSelectedTab = _vm.ViewProfileTabs.Data
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.T.profilePersonalData))]
                  ),
                  _vm.profile.is_own_profile || !_vm.profile.is_private
                    ? _c(
                        "a",
                        {
                          staticClass: "nav-item nav-link",
                          class: {
                            active:
                              _vm.currentSelectedTab ===
                              _vm.ViewProfileTabs.Charts
                          },
                          attrs: { href: "#" + _vm.ViewProfileTabs.Charts },
                          on: {
                            click: function($event) {
                              _vm.currentSelectedTab =
                                _vm.ViewProfileTabs.Charts
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.T.wordsStatistics))]
                      )
                    : _vm._e()
                ]
              ),
              _c("div", { staticClass: "tab-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade show active",
                    attrs: { role: "tab", "aria-labelledby": "nav-badges-tab" }
                  },
                  [
                    _vm.currentSelectedTab == _vm.ViewProfileTabs.Badges
                      ? _c("omegaup-badge-list", {
                          attrs: {
                            "all-badges": _vm.profileBadges,
                            "show-all-badges-link": true,
                            "visitor-badges": _vm.visitorBadges
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm.currentSelectedTab == _vm.ViewProfileTabs.Problems
                  ? _c(
                      "div",
                      {
                        staticClass: "tab-pane fade show active",
                        attrs: {
                          role: "tab",
                          "aria-labelledby": "nav-problems-tab"
                        }
                      },
                      [
                        _c("omegaup-grid-paginator", {
                          staticClass: "mb-3",
                          attrs: {
                            columns: 3,
                            items: _vm.solvedProblems,
                            "items-per-page": 30,
                            title: _vm.T.profileSolvedProblems,
                            "should-show-filter-input": true
                          }
                        }),
                        _c("omegaup-grid-paginator", {
                          staticClass: "mb-3",
                          attrs: {
                            columns: 3,
                            items: _vm.unsolvedProblems,
                            "items-per-page": 30,
                            title: _vm.T.profileUnsolvedProblems
                          }
                        }),
                        _c("omegaup-grid-paginator", {
                          staticClass: "mb-3",
                          attrs: {
                            columns: 3,
                            items: _vm.createdProblems,
                            "items-per-page": 30,
                            title: _vm.T.profileCreatedProblems
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.currentSelectedTab ==
                          _vm.ViewProfileTabs.Contests,
                        expression:
                          "currentSelectedTab == ViewProfileTabs.Contests"
                      }
                    ],
                    staticClass: "tab-pane fade show active",
                    attrs: {
                      role: "tab",
                      "aria-labelledby": "nav-contests-tab"
                    }
                  },
                  [
                    _c("omegaup-table-paginator", {
                      attrs: {
                        "column-names": _vm.columnNames,
                        items: _vm.contests,
                        "items-per-page": 15
                      }
                    })
                  ],
                  1
                ),
                _vm.currentSelectedTab == _vm.ViewProfileTabs.CreatedContent
                  ? _c(
                      "div",
                      {
                        staticClass: "tab-pane fade show active",
                        attrs: {
                          role: "tab",
                          "aria-labelledby": "nav-created-content-tab"
                        }
                      },
                      [
                        _c("omegaup-grid-paginator", {
                          staticClass: "mb-3",
                          attrs: {
                            columns: 3,
                            items: _vm.createdProblems,
                            "items-per-page": 30,
                            title: _vm.T.profileCreatedProblems
                          },
                          scopedSlots: _vm._u(
                            [
                              _vm.profile.is_own_profile
                                ? {
                                    key: "header-link",
                                    fn: function() {
                                      return [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "float-right align-self-center",
                                            attrs: { href: "/problem/mine/" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.T
                                                  .profileCreatedContentSeeAll
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                : null
                            ],
                            null,
                            true
                          )
                        }),
                        _c("omegaup-grid-paginator", {
                          staticClass: "mb-3",
                          attrs: {
                            columns: 3,
                            items: _vm.createdContests,
                            "items-per-page": 30,
                            title: _vm.T.profileCreatedContests
                          },
                          scopedSlots: _vm._u(
                            [
                              _vm.profile.is_own_profile
                                ? {
                                    key: "header-link",
                                    fn: function() {
                                      return [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "float-right align-self-center",
                                            attrs: { href: "/contest/mine/" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.T
                                                  .profileCreatedContentSeeAll
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                : null
                            ],
                            null,
                            true
                          )
                        }),
                        _c("omegaup-grid-paginator", {
                          staticClass: "mb-3",
                          attrs: {
                            columns: 3,
                            items: _vm.createdCourses,
                            "items-per-page": 30,
                            title: _vm.T.profileCreatedCourses
                          },
                          scopedSlots: _vm._u(
                            [
                              _vm.profile.is_own_profile
                                ? {
                                    key: "header-link",
                                    fn: function() {
                                      return [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "float-right align-self-center",
                                            attrs: { href: "/course/mine/" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.T
                                                  .profileCreatedContentSeeAll
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                : null
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.currentSelectedTab == _vm.ViewProfileTabs.Data
                  ? _c(
                      "div",
                      {
                        staticClass: "tab-pane fade show active",
                        attrs: {
                          role: "tab",
                          "aria-labelledby": "nav-user-info-tab"
                        }
                      },
                      [
                        _c("omegaup-user-basicinfo", {
                          attrs: { profile: _vm.profile, rank: _vm.rank }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.currentSelectedTab == _vm.ViewProfileTabs.Charts
                  ? _c(
                      "div",
                      {
                        staticClass: "tab-pane fade show active",
                        attrs: {
                          role: "tab",
                          "aria-labelledby": "nav-charts-tab"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "chart-section" },
                          [
                            _vm.charts
                              ? _c("omegaup-user-charts", {
                                  attrs: {
                                    data: _vm.charts,
                                    username: _vm.profile.username
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "chart-section-heatmap" },
                          [
                            _c("omegaup-user-heatmap", {
                              attrs: {
                                username: _vm.profile.username,
                                "available-years": _vm.availableYears,
                                data: _vm.charts
                              },
                              on: {
                                "year-changed": function(year) {
                                  return _vm.$emit("heatmap-year-changed", year)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }